/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import ICONS from "../../../../assets/Icons";
import StatusContainer from "../../../../components/_utils/CommonStatus/StatusContainer";
import InfoCard from "../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import TabsWeapperSection from "../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import { formatAccountNumber } from "../../../../components/_utils/FormatAccountNumber";
import FormatAmount from "../../../../components/_utils/FormatAmount/FormatAmount";
import { setHideBreadCrumb } from "../../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import { scheduledBeneficiaryDetailsById } from "../../../../redux/features/transactions/scheduleBeneficiaryTransactions/index.js";
import globalText from "../../../../utils/globalText";
import { globalTextFormat } from "../../../../utils/globalTextFormat";
import useCategories from "../../../../utils/useCategories";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";

const ScheduleBeneficiaryTransactionSuccess = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const prevIdRef = useRef(null);
  const categoryMapper = useCategories();

  const { scheduledBeneficiaryDetailsData } = useSelector(
    (s) => s.scheduleBeneficiaryTransactions,
  );
  const frequency =
    scheduledBeneficiaryDetailsData?.transaction?.[0]?.frequency;

  const capitalizedFrequency = frequency
    ? frequency.charAt(0).toUpperCase() + frequency.slice(1).toLowerCase()
    : "";

  const formateDate = (date) => {
    const dates = new Date(date || new Date());
    const day = dates.toLocaleDateString("en-GB", {
      day: "2-digit",
    });
    const month = dates.toLocaleDateString("en-GB", {
      month: "short",
    });
    const year = dates.toLocaleDateString("en-GB", {
      year: "numeric",
    });
    return `${day} ${month}, ${year}`;
  };

  const categoryId =
    scheduledBeneficiaryDetailsData?.transaction?.[0]?.category_id?.category_id;

  const categoryIcon = categoryMapper(categoryId);

  const beneAccount = () => {
    const beneId =
      scheduledBeneficiaryDetailsData?.transaction?.[0]?.beneficiary_account_id;
    navigate(
      `/beneficiary_account_dashboard/beneficiary_account_view_all/beneficiary_account_detail_page/${beneId}`,
      { replace: true },
    );
  };

  const sourceAccount = () => {
    const sourceId =
      scheduledBeneficiaryDetailsData?.transaction?.[0]?.owner_account_id;
    navigate(
      `/owner_account_dashboard/owner_accounts_view_all/owner_accounts_detail_page/${sourceId}`,
      { replace: true },
    );
  };

  const createScheduleTxn = () => {
    navigate("/beneficiary_transaction_dashboard/create_schedule", {
      replace: true,
    });
  };
  const viewScheduleTxn = () => {
    navigate(
      `/beneficiary_transaction_dashboard/schedule_view_all/schedule_detail_page/${id}`,
      { replace: true },
    );
  };
  const goToDashboard = () => {
    navigate("/beneficiary_transaction_dashboard", { replace: true });
  };

  const buttonRows = [
    [
      {
        btnText: "Create schedule",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: ICONS?.ADD_BUTTON_WHITE,
        handleFunction: createScheduleTxn,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
      {
        btnText: "View details",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: ICONS?.VIEW_DETAILS,
        handleFunction: viewScheduleTxn,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
    ],
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--bg-positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS?.DASHBOARD,
        handleFunction: goToDashboard,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "dark",
      },
    ],
  ];

  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  useEffect(() => {
    if (!id) return;

    if (prevIdRef.current === id) return;

    prevIdRef.current = id;

    dispatch(scheduledBeneficiaryDetailsById({ id }));
  }, [id, dispatch]);

  return (
    <div>
      <StatusContainer
        status="success"
        buttonRows={buttonRows}
        title={
          scheduledBeneficiaryDetailsData?.transaction?.[0]
            ?.lifecycle_status === "approved"
            ? globalText?.SCHEDULE_BENE_CREATED_AND_APPROVED
            : globalText?.SCHEDULE_CREATED_SUCCESS
        }
        subtitle=""
      >
        <TabsWeapperSection
          title={globalTextFormat(globalText?.TRANSFER_DETAILS, [0])}
        >
          <>
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle:
                    scheduledBeneficiaryDetailsData?.transaction?.[0]
                      ?.scheduled_name,
                  leftSubTitle: globalTextFormat(globalText?.SCHEDULE_NAME, [
                    0,
                  ]),
                  hasRight: true,
                  rightText: true,
                  rightTitle: (
                    <>
                      INR{" "}
                      <FormatAmount
                        price={
                          scheduledBeneficiaryDetailsData?.transaction?.[0]
                            ?.amount
                        }
                      />
                    </>
                  ),
                  rightTextFontWeight: "semibold",
                  rightTitleTextColor: "var(--text-primary)",
                  rightSubTitle: "Amount",
                },
              ]}
            />

            <InfoCard
              bgColor="var(--positive-card)"
              onClick={sourceAccount}
              hoverable="black"
              rows={[
                {
                  leftTitle: formatAccountNumber(
                    scheduledBeneficiaryDetailsData?.transaction?.[0]
                      ?.owner_account_bank_acc_no,
                  ),
                  leftSubTitle: globalTextFormat(
                    globalText?.SOURCE_ACCOUNT_DETAILS,
                    [0],
                  ),
                  ifsc: scheduledBeneficiaryDetailsData?.transaction?.[0]
                    ?.owner_account_ifsc_code,
                  rightIcon: true,
                },
              ]}
            />

            <InfoCard
              bgColor="var(--positive-card)"
              onClick={beneAccount}
              hoverable="black"
              rows={[
                {
                  leftTitle: formatAccountNumber(
                    scheduledBeneficiaryDetailsData?.transaction?.[0]
                      ?.beneficiary_account_bank_acc_no,
                  ),
                  leftSubTitle: globalTextFormat(
                    globalText?.DESTINATION_ACCOUNT_DETAILS,
                    [0],
                  ),
                  ifsc: scheduledBeneficiaryDetailsData?.transaction?.[0]
                    ?.beneficiary_account_ifsc_code,
                  rightIcon: true,
                },
              ]}
            />

            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle:
                    scheduledBeneficiaryDetailsData?.transaction?.[0]
                      ?.category_id?.category_name || "Not available",
                  leftSubTitle: globalTextFormat(
                    globalText?.TRANSACTION_CATEGORY,
                    [0],
                  ),
                  icon: categoryIcon?.url,
                  iconColor: categoryIcon?.colour,
                  iconSize: "small",
                },
              ]}
            />

            {scheduledBeneficiaryDetailsData?.transaction?.[0]
              ?.confidential_transaction === "Y" && (
              <InfoCard
                bgColor="var(--positive-card)"
                rows={[
                  {
                    leftTitle:
                      scheduledBeneficiaryDetailsData?.transaction?.[0]
                        ?.confidential_transaction === "Y"
                        ? "Yes"
                        : "No",
                    leftSubTitle: globalTextFormat(
                      globalText?.CONFIDENTIAL_TRANSACTION,
                      [0],
                    ),
                    icon: ICONS?.CONFIDENTIAL_TRANSACTION_BLUE_BG,
                  },
                ]}
              />
            )}
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle:
                    Array.isArray(
                      scheduledBeneficiaryDetailsData?.transaction?.[0]?.labels,
                    ) &&
                    scheduledBeneficiaryDetailsData?.transaction?.[0]?.labels
                      .length > 0
                      ? scheduledBeneficiaryDetailsData?.transaction?.[0]?.labels.map(
                          (item, index, arr) => (
                            <span key={item}>
                              {item}
                              {index <
                                arr.length -
                                  GlobalConfiguration?.lengthCheckOne && ", "}
                            </span>
                          ),
                        )
                      : globalText?.NO_LABELS_ASSIGNED,
                  leftSubTitle: "Assigned labels",
                },
              ]}
            />
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: id,
                  leftSubTitle: "Transaction ID",
                  copyText: id,
                },
              ]}
            />
          </>
        </TabsWeapperSection>
        <TabsWeapperSection
          title={globalTextFormat(globalText?.SCHEDULE_DETAILS, [0])}
        >
          <>
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: capitalizedFrequency,
                  leftSubTitle: globalText?.FREQUENCY,
                },
              ]}
            />

            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: formateDate(
                    scheduledBeneficiaryDetailsData?.transaction?.[0]
                      ?.transaction_start_date,
                  ),
                  leftSubTitle: globalTextFormat(
                    scheduledBeneficiaryDetailsData?.transaction?.[0]
                      ?.frequency === "once"
                      ? globalText?.ON_DATE
                      : globalText?.FIRST_OCCURRENCES_DATE,
                    [0],
                  ),
                },
              ]}
            />

            {scheduledBeneficiaryDetailsData?.transaction?.[0]?.frequency !==
              "once" && (
              <>
                <InfoCard
                  bgColor="var(--positive-card)"
                  rows={[
                    {
                      leftTitle: formateDate(
                        scheduledBeneficiaryDetailsData?.transaction?.[0]
                          ?.transaction_start_date,
                      ),
                      leftSubTitle: globalTextFormat(globalText?.START_DATE, [
                        0,
                      ]),
                    },
                  ]}
                />

                <InfoCard
                  bgColor="var(--positive-card)"
                  rows={[
                    {
                      leftTitle: formateDate(
                        scheduledBeneficiaryDetailsData?.transaction?.[0]
                          ?.transaction_end_date,
                      ),
                      leftSubTitle: globalText?.END_DATE,
                    },
                  ]}
                />
              </>
            )}

            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: scheduledBeneficiaryDetailsData?.transaction?.[0]
                    ?.slot
                    ? (() => {
                        const [startRaw, endRaw] =
                          scheduledBeneficiaryDetailsData?.transaction?.[0]?.slot.split(
                            " - ",
                          );
                        const formatTo12Hour = (timeStr) => {
                          const cleaned = timeStr
                            .trim()
                            .replace(/\s?(am|pm)$/i, "");
                          const [hours, minutes] = cleaned
                            .split(":")
                            .map(Number);

                          const date = new Date();
                          date.setHours(hours);
                          date.setMinutes(minutes);
                          const formatted = date.toLocaleTimeString("en-US", {
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: true,
                          });

                          const [time, ampm] = formatted.split(" ");
                          return (
                            <>
                              {time}&nbsp;
                              <span className="text-font-md lowercase">
                                {ampm}
                              </span>
                            </>
                          );
                        };

                        return (
                          <>
                            {formatTo12Hour(startRaw)} to{" "}
                            {formatTo12Hour(endRaw)}
                          </>
                        );
                      })()
                    : globalText?.NOT_AVAILABLE,
                  leftSubTitle: globalTextFormat(globalText?.TIME_SLOT, [0]),
                },
              ]}
            />

            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle:
                    scheduledBeneficiaryDetailsData?.transaction?.[0]
                      ?.occurrences,
                  leftSubTitle: globalTextFormat(globalText?.OCCURRENCES, [0]),
                },
              ]}
            />
          </>
        </TabsWeapperSection>
      </StatusContainer>
    </div>
  );
};

export default ScheduleBeneficiaryTransactionSuccess;
